import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Shown in place of content whose request failed (see helpers/loadResult):
 * the page exists, it just could not be loaded this time.
 */
export default function LoadError({ onRetry, className = "" }) {
  const { t } = useTranslation();
  return (
    <div className={`avc-empty avc-load-error ${className}`.trim()} role="alert">
      <span className="avc-empty__icon">
        <i className="fas fa-wifi" aria-hidden="true"></i>
      </span>
      <h2 className="avc-empty__title">{t("load_failed_title")}</h2>
      <p className="avc-empty__text">{t("load_failed_text")}</p>
      <button type="button" className="avc-btn avc-btn--outline avc-load-error__retry" onClick={onRetry}>
        <i className="fas fa-redo" aria-hidden="true"></i>
        {t("load_failed_retry")}
      </button>
    </div>
  );
}
